<form novalidate [formGroup]="residenceInfoForm" [ngClass]='{"h-100": !isBuyNow && !isLegacyCreditApp}'>
  <div class="row m-0 residence-info credit-app-body" [ngClass]='{"noshadow": isBuyNow || isLegacyCreditApp, "pl-4 pr-4": !isBuyNow && !isLegacyCreditApp}'>

    <div class="col-12 col-lg-11 {{isBuyNow || isLegacyCreditApp ? 'col-xl-11-half' : ''}} scrollDiv nopad" [ngClass]="{ 'rightPadding': isLegacyCreditApp}">
      <div class="row m-0 mt-1-md">
        <!-- *************************** ResidenceType START ***************************  -->
        <div class="col-12 col-lg-6 col-xl-4 px-0 pr-lg-3">
          <label for="residence_type">{{ residenceInfoConfigData?.ResidenceTypeLabel }}</label>
          <select class="form-control w-100 gradient" id="residence_type" formControlName="ResidenceType" [ngClass]="{'error': !residenceInfoForm.get('ResidenceType').valid &&
                                            (formSubmitAttempt ||
                                              (residenceInfoForm.get('ResidenceType').touched
                                                  || residenceInfoForm.get('ResidenceType').dirty)) }">
            <option value="" [selected]="residenceInfoForm.get('ResidenceType').value === '' ||
                                          residenceInfoForm.get('ResidenceType').value === 0 ||
                                          residenceInfoForm.get('ResidenceType').value === null ">
              {{ creditAppConfigData?.SelectsDefaultLabel }}
            </option>
            <option *ngFor="let residenceType of residenceTypes" [value]="residenceType.Value"
                    [selected]="residenceType.Value === residenceInfoForm.get('ResidenceType').value">
              {{ residenceType?.Description }}
            </option>
          </select>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!residenceInfoForm.get('ResidenceType').valid &&
                              (formSubmitAttempt ||
                                (residenceInfoForm.get('ResidenceType').touched
                                    || residenceInfoForm.get('ResidenceType').dirty))">
              <ng-container *ngIf="!!residenceInfoForm.get('ResidenceType').errors?.required">
                {{ residenceInfoConfigData?.ResidenceTypeRequired }}
              </ng-container>
            </span>
          </div>
        </div>
        <!-- *************************** ResidenceType END ***************************  -->

        <!-- *************************** RentOrMortgageAmt START ***************************  -->
        <div class="col-md-5 px-0" [ngClass]="{ 'col-12 col-lg-6 col-xl-4': type === 'buyer', 'col-6  col-lg-3 pr-2': type !== 'buyer' }">
          <label for="rent_or_mortgage_amt">{{ residenceInfoConfigData?.MonthlyRentMortgageLabel }}</label>
          <div class="dollar-symbol px-0" [ngClass]="{ 'col-lg-6 pr-lg-3 col-xl-8': type === 'buyer', 'col-lg-12': type !== 'buyer' }">
            <input class="form-control w-100 "
                    id="rent_or_mortgage_amt"
                    formControlName="RentOrMortgageAmt"
                    [ngClass]="{'error': !residenceInfoForm.get('RentOrMortgageAmt').valid &&
                                          (residenceInfoForm.get('RentOrMortgageAmt').touched ||
                                            residenceInfoForm.get('RentOrMortgageAmt').dirty ||
                                            (formSubmitAttempt && !rentOrMortgageAmtCleared))}" type="text"
                    [dtTextMask]="{ mask: numberMask, guide:false }"
                    maxlength="5" />
            <span role="button" class="form-error-x dt-icon dt-icon-input-clear rent-mortgage-x error-x" [ngClass]="{'rent-co-buyer-x': type !== 'buyer'}"
                  *ngIf="!residenceInfoForm.get('RentOrMortgageAmt').valid &&
                              (residenceInfoForm.get('RentOrMortgageAmt').touched ||
                                residenceInfoForm.get('RentOrMortgageAmt').dirty ||
                                (formSubmitAttempt && !rentOrMortgageAmtCleared))"
                  (click)="clearValidations(residenceInfoForm.get('RentOrMortgageAmt'))" aria-label="Clear rent amount"
                  (keyup)="$event?.keyCode ===  13 ? clearValidations(residenceInfoForm.get('RentOrMortgageAmt')) : null"
                  tabindex="3">

            </span>
          </div>
          <div class="form-validator_error" [ngClass]="{ 'rent-mortgage-error-msg': type === 'buyer', 'rent-mortgage-error-msg-cobuyer': type !== 'buyer' }">
            <span class="invalid-feedback d-block" *ngIf="!residenceInfoForm.get('RentOrMortgageAmt').valid &&
                              (residenceInfoForm.get('RentOrMortgageAmt').touched ||
                                residenceInfoForm.get('RentOrMortgageAmt').dirty ||
                                (formSubmitAttempt && !rentOrMortgageAmtCleared))">
              <ng-container *ngIf="!!residenceInfoForm.get('RentOrMortgageAmt').errors?.required">
                {{ residenceInfoConfigData?.MonthlyRentMortgageRequired }}
              </ng-container>
            </span>
          </div>
        </div>
        <!-- *************************** RentOrMortgageAmt END ***************************  -->

        <!-- *************************** SameAddressAsBuyer START ***************************  -->
        <div *ngIf="type !== 'buyer'" class="col-6 col-lg-3 px-0 pl-2 same-address">
          <div class="custom-checkbox">
            <input id="sameAddress" type="checkbox" formControlName="SameAddressAsBuyer">
            <label id="sameAddress_label" for="sameAddress">{{ residenceInfoConfigData?.SameAddressLabel }}</label>
          </div>
        </div>
      <!--   <div class="form-validator_error" [ngClass]="{'rent-mortgage-error-msg-cobuyer d-block d-sm-none': type !== 'buyer' }">
            <span class="invalid-feedback d-block" *ngIf="!residenceInfoForm.get('RentOrMortgageAmt').valid &&
                              (residenceInfoForm.get('RentOrMortgageAmt').touched ||
                                residenceInfoForm.get('RentOrMortgageAmt').dirty ||
                                (formSubmitAttempt && !rentOrMortgageAmtCleared))">
              <ng-container *ngIf="!!residenceInfoForm.get('RentOrMortgageAmt').errors?.required">
                {{ residenceInfoConfigData?.MonthlyRentMortgageRequired }}
              </ng-container>
            </span>
          </div> -->
        <div class="d-none d-xl-block col-xl-4" *ngIf="type === 'buyer'">

        </div>
        <!-- *************************** SameAddressAsBuyer END ***************************  -->

        <!-- *************************** Address1 START ***************************  -->
        <div class="col-12 col-lg-6 col-xl-4 mr-lg-0 px-0 pr-lg-3">
          <label for="address1">{{ residenceInfoConfigData?.AddressLine1label }}</label>
          <div class="form-group sbc" id='searchBoxContainer'>
            <input class="form-control w-100 pr-5" id="address1" formControlName="Address1" [ngClass]="{'error': !residenceInfoForm.get('Address1').valid &&
                                              (residenceInfoForm.get('Address1').touched ||
                                                residenceInfoForm.get('Address1').dirty ||
                                                (formSubmitAttempt && !address1Cleared)) }" type="text" maxlength="40" />

          </div>
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 error-x" *ngIf="!residenceInfoForm.get('Address1').valid &&
                              (residenceInfoForm.get('Address1').touched ||
                                residenceInfoForm.get('Address1').dirty ||
                                (formSubmitAttempt && !address1Cleared))"
                  (click)="clearValidations(residenceInfoForm.get('Address1'))" aria-label="Clear address1"
                  (keyup)="$event?.keyCode ===  13 ? clearValidations(residenceInfoForm.get('Address1')) : null">

          </span>
            <div class="form-validator_error">
                <span class="invalid-feedback d-block" *ngIf="!residenceInfoForm.get('Address1').valid &&
                                  (residenceInfoForm.get('Address1').touched ||
                                    residenceInfoForm.get('Address1').dirty ||
                                    (formSubmitAttempt && !address1Cleared))">
                  <ng-container *ngIf="!!residenceInfoForm.get('Address1').errors?.required; else second">
                    {{ residenceInfoConfigData?.AddressLine1required }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="!!residenceInfoForm.get('Address1').errors?.pattern">
                      {{residenceInfoConfigData?.AddressLine1invalid}}
                    </ng-container>
                  </ng-template>
                </span>
            </div>
        </div>
        <!-- *************************** Address1 END ***************************  -->

        <!-- *************************** Address2 START ***************************  -->
        <div class="col-12 col-lg-6 col-xl-4 px-0 pr-lg-3">
          <label for="address2">{{ residenceInfoConfigData?.AddressLine2label }}</label>
          <input class="form-control w-100 pr-5" id="address2" formControlName="Address2" [ngClass]="{'error': !residenceInfoForm.get('Address2').valid &&
                                          (residenceInfoForm.get('Address2').touched ||
                                            residenceInfoForm.get('Address2').dirty ||
                                            (formSubmitAttempt && !address2Cleared)) }" type="text" maxlength="40" />
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 error-x" *ngIf="!residenceInfoForm.get('Address2').valid &&
                            (residenceInfoForm.get('Address2').touched ||
                              residenceInfoForm.get('Address2').dirty ||
                              (formSubmitAttempt && !address2Cleared))"
                (click)="clearValidations(residenceInfoForm.get('Address2'))" aria-label="Clear address2"
                (keyup)="$event?.keyCode ===  13 ? clearValidations(residenceInfoForm.get('Address2')) : null">
          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!residenceInfoForm.get('Address2').valid &&
                              (residenceInfoForm.get('Address2').touched ||
                                residenceInfoForm.get('Address2').dirty ||
                                (formSubmitAttempt && !address2Cleared))">
              <ng-container *ngIf="!!residenceInfoForm.get('Address2').errors?.pattern">
                {{ residenceInfoConfigData?.AddressLine2invalid }}
              </ng-container>
            </span>
          </div>
        </div>
        <div class="d-none d-xl-block col-xl-4">

        </div>
        <!-- *************************** Address2 END ***************************  -->

        <!-- *************************** Zipcode START ***************************  -->
        <div class="col-12 col-md-4 col-lg-4 col-xl-2 px-0 pr-md-3">
          <label for="zip_code">{{ residenceInfoConfigData?.ZipCodeLabel }}</label>
          <div class="mr-lg-0">
            <input class="form-control w-100 pr-4" id="zip_code" formControlName="Zipcode" [ngClass]="{'error': !residenceInfoForm.get('Zipcode').valid &&
                                                      (residenceInfoForm.get('Zipcode').touched ||
                                                        residenceInfoForm.get('Zipcode').dirty ||
                                                        (formSubmitAttempt && !zipCodeCleared)) }" type="text"
                   [dtTextMask]="{ mask: zipCodeMask, guide:false }" />
            <a href="javascript:void(0);" class="locateMeButton" (click)="getBrowserZipcode()">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13" height="14" viewBox="0 0 13 14"><defs><style>.a{fill:none;}.b{clip-path:url(#a);}.c{fill:var(--pink-600);}</style><clipPath id="a"><path class="a" d="M0,0H13V14H0Z"/></clipPath></defs><path class="a" d="M0,0H13V14H0Z"/><g class="b"><path class="c" d="M9.072,14a.459.459,0,0,1-.462-.433L6.73,8.626a.462.462,0,0,0-.438-.3H6.268L.525,8.485a.475.475,0,0,1-.061,0,.467.467,0,0,1-.422-.265.444.444,0,0,1-.014-.345A.454.454,0,0,1,.27,7.622L12.261.077A.473.473,0,0,1,12.515,0V.027h.023a.467.467,0,0,1,.139.021.457.457,0,0,1,.273.227.443.443,0,0,1,.029.343L9.535,13.522a.446.446,0,0,1-.115.324A.463.463,0,0,1,9.1,14ZM6.254,7.231H6.3a1.584,1.584,0,0,1,1.472,1l1.2,3.157,2.55-9.571.005,0L2.732,7.331Z"/></g></svg>
            </a>
          </div>
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 error-x zip-error-x" *ngIf="!residenceInfoForm.get('Zipcode').valid &&
                            (residenceInfoForm.get('Zipcode').touched ||
                              residenceInfoForm.get('Zipcode').dirty ||
                              (formSubmitAttempt && !zipCodeCleared))"
                (click)="clearValidations(residenceInfoForm.get('Zipcode'))" aria-label="Clear zipcode"
                (keyup)="$event?.keyCode ===  13 ? clearValidations(residenceInfoForm.get('Zipcode')) : null" tabindex="3">
          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!residenceInfoForm.get('Zipcode').valid &&
                              (residenceInfoForm.get('Zipcode').touched ||
                                residenceInfoForm.get('Zipcode').dirty ||
                                (formSubmitAttempt && !zipCodeCleared))">
              <ng-container *ngIf="!!residenceInfoForm.get('Zipcode').errors?.required; else second">
                {{ residenceInfoConfigData?.ZipCodeRequired }}
              </ng-container>
              <ng-template #second>
                <ng-container *ngIf="!!residenceInfoForm.get('Zipcode').errors?.minlength; else third">
                  {{residenceInfoConfigData?.ZipCodeInvalid}}
                </ng-container>
                <ng-template #third>
                  <ng-container *ngIf="!!residenceInfoForm.get('Zipcode').errors?.invalidZipCode">
                    {{residenceInfoConfigData?.ZipCodeInvalid}}
                  </ng-container>
                </ng-template>
              </ng-template>
            </span>
          </div>
        </div>
        <!-- *************************** Zipcode END ***************************  -->

        <!-- *************************** City START ***************************  -->
        <div class="col-12 col-md-8 col-lg-5 col-xl-3 px-0 pr-lg-3">
          <label for="city">{{ residenceInfoConfigData?.CityLabel }}</label>
          <input class="form-control w-100 pr-5" id="city" formControlName="City" [ngClass]="{'error': !residenceInfoForm.get('City').valid &&
                                            (residenceInfoForm.get('City').touched ||
                                              residenceInfoForm.get('City').dirty ||
                                              (formSubmitAttempt && !cityCleared)) }" type="text" maxlength="30" />
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 error-x" *ngIf="!residenceInfoForm.get('City').valid &&
                            (residenceInfoForm.get('City').touched ||
                              residenceInfoForm.get('City').dirty ||
                              (formSubmitAttempt && !cityCleared))"
                (click)="clearValidations(residenceInfoForm.get('City'))" aria-label="Clear city"
                (keyup)="$event?.keyCode ===  13 ? clearValidations(residenceInfoForm.get('City')) : null" tabindex="3">
          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!residenceInfoForm.get('City').valid &&
                              (residenceInfoForm.get('City').touched ||
                                residenceInfoForm.get('City').dirty ||
                                (formSubmitAttempt && !cityCleared))">
              <ng-container *ngIf="!!residenceInfoForm.get('City').errors?.required; else second">
                {{ residenceInfoConfigData?.CityRequired }}
              </ng-container>
              <ng-template #second>
                <ng-container *ngIf="!!residenceInfoForm.get('City').errors?.pattern">
                  {{residenceInfoConfigData?.CityInvalid}}
                </ng-container>
              </ng-template>
            </span>
          </div>
        </div>
        <!-- *************************** City END ***************************  -->

        <!-- *************************** State START ***************************  -->
        <div class="col-12 col-md-3 col-lg-2 {{isBuyNow || isLegacyCreditApp ? 'col-xl-1-half' : ''}} px-0 pl-2-lg pl-md-0 pr-xl-3">
          <label for="state">{{ residenceInfoConfigData?.StateLabel }}</label>
          <select class="form-control w-100 gradient" id="state" formControlName="State"
                  [ngClass]="{'error': !residenceInfoForm.get('State').valid &&
                                            (formSubmitAttempt ||
                                              (residenceInfoForm.get('State').touched
                                                  || residenceInfoForm.get('State').dirty)) }">
            <option value="" [selected]="residenceInfoForm.get('State').value === '' ||
                                          residenceInfoForm.get('State').value === null">
              {{ creditAppConfigData?.SelectsDefaultLabel }}
            </option>
            <option *ngFor="let state of states" [value]="state.Value"
                    [selected]="state.Value === residenceInfoForm.get('State').value">
              {{ state?.Description }}
            </option>
          </select>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!residenceInfoForm.get('State').valid &&
                              (formSubmitAttempt ||
                                (residenceInfoForm.get('State').touched
                                    || residenceInfoForm.get('State').dirty))">
              <ng-container *ngIf="!!residenceInfoForm.get('State').errors?.required">
                {{ residenceInfoConfigData?.StateRequired }}
              </ng-container>
            </span>
          </div>
        </div>
        <!-- *************************** State END ***************************  -->

        <!-- *************************** residenceDurationGroup START ***************************  -->
        <!-- <div class="break"></div> -->
        <div formGroupName="residenceDurationGroup" class="col-12 col-lg-9 {{isBuyNow || isLegacyCreditApp ? 'col-xl-5' : 'col-xl-4'}} px-0 totalYears" [ngClass]="{'group-padding': !isBuyNow && !isLegacyCreditApp}">
          <div class="row m-0 p-0">
            <!-- *************************** YearsAtAddress START ***************************  -->
            <div class="{{isLegacyCreditApp && isMobile() ? 'col-12' : 'col'}} years-months p-0 pl-0 {{isLegacyCreditApp && isMobile() ? 'pr-0' : 'pr-2'}}">
              <label for="years_at_address" class="d-block">{{ residenceInfoConfigData?.TotalYearsLabel }}</label>
              <select class="form-control gradient" id="years_at_address" formControlName="YearsAtAddress"
                      [ngClass]="{'error': residenceInfoForm.get('residenceDurationGroup').errors ||
                                      (!residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').valid &&
                                        (formSubmitAttempt ||
                                          (residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').touched
                                            || residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').dirty)))}">
                <option value="" [selected]="residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').value === ''
                                             || residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').value === null">
                  {{ creditAppConfigData?.SelectsDefaultLabel }}
                </option>
                <option *ngFor="let year of totalYearsAtAddress" [value]="year.Value"
                        [selected]="year.Value === residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').value">
                  {{ year?.Description }}
                </option>
              </select>
              <div class="form-validator_error">
                <span class="invalid-feedback d-block"
                      *ngIf="residenceInfoForm.get('residenceDurationGroup').errors ||
                              (!residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').valid &&
                                (formSubmitAttempt ||
                                  (residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').touched
                                    || residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').dirty)))">
                  <ng-container *ngIf="!!residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').errors?.required; else second">
                    {{ residenceInfoConfigData?.TotalYearsRequired }}
                  </ng-container>
                  <ng-template #second>
                      <ng-container *ngIf="!!residenceInfoForm.get('residenceDurationGroup').errors?.invalidselection">
                          {{ residenceInfoConfigData?.TotalYrsZeroValidation }}
                        </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>
            <!-- *************************** YearsAtAddress END ***************************  -->

            <!-- *************************** MonthsAtAddress START ***************************  -->
            <div class="{{isLegacyCreditApp && isMobile()  ? 'col-12' : 'col'}} years-months p-0 {{isLegacyCreditApp && isMobile() ? 'pl-0' : 'pl-2'}} pr-0">
              <label for="months_at_address" class="d-block">{{ residenceInfoConfigData?.TotalMonthsLabel }}</label>
              <select class="form-control gradient" id="months_at_address" formControlName="MonthsAtAddress"
                      [ngClass]="{'error': residenceInfoForm.get('residenceDurationGroup').errors ||
                                    (!residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').valid &&
                                      (formSubmitAttempt ||
                                        (residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').touched
                                          || residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').dirty)))}">
                <option value="" [selected]="residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').value === ''
                                            || residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').value === null">
                  {{ creditAppConfigData?.SelectsDefaultLabel }}
                </option>
                <option *ngFor="let month of totalMonthsAtAddress" [value]="month.Value"
                        [selected]="month.Value === residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').value">
                  {{ month?.Description }}
                </option>
              </select>
              <div class="form-validator_error">
                <span class="invalid-feedback d-block"
                      *ngIf="residenceInfoForm.get('residenceDurationGroup').errors ||
                              (!residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').valid &&
                                (formSubmitAttempt ||
                                  (residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').touched
                                    || residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').dirty)))">
                  <ng-container *ngIf="!!residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').errors?.required; else second">
                    {{ residenceInfoConfigData?.TotalMonthsRequired }}
                  </ng-container>
                  <ng-template #second>
                      <ng-container *ngIf="!!residenceInfoForm.get('residenceDurationGroup').errors?.invalidselection">
                          {{ residenceInfoConfigData?.TotalMnthsZeroValidation }}
                        </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>
            <!-- *************************** MonthsAtAddress END ***************************  -->
          </div>
        </div>
        <!-- *************************** residenceDurationGroup END ***************************  -->
      </div>
    </div>
  </div>



</form>

<div class="credit-app-cta-section">
  <div class="row m-0 w-100 cta-section">
    <div class="col-12 p-0 d-flex cta-col cta-alignment m-0">
      <button
        id="back_cta"
        type="button"
        class="secondary-cta mr-auto"
        [disabled]="isSaving"
        (click)="goBack()"
      >
        {{  residenceInfoConfigData?.BackCta  }}
      </button>
      <button
        id="next_cta"
        class="primary-cta ml-auto"
        [disabled]="!residenceInfoForm.valid  || isSaving"
        (click)="goNext()"
      >
        {{residenceInfoConfigData?.NextCta }}
      </button>
    </div>
  </div>
</div>

